/**
 * 项目默认配置项
 * primaryColor - 默认主题色, 如果修改颜色不生效，请清理 localStorage
 * contentWidth - 内容区布局： 流式 |  固定
 */

export default {
  // primaryColor: '#52C41A', // primary color of ant design
  primaryColor: '#ff5c00', // primary color of ant design
  contentWidth: 'Fixed', // layout of content: Fluid or Fixed, only works when layout is topmenu

  // vue-ls options
  storageOptions: {
    namespace: 'pro__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local' // storage name session, local, memory
  }
}
